// extracted by mini-css-extract-plugin
export default {"fwButton":"ToggleButton_fwButton__7lixa","slideAndShow":"ToggleButton_slideAndShow__DvXHu","active":"ToggleButton_active__xQVoy"};